import { createSelector } from 'reselect';

const getCurrentViewFromState = state => state.getIn(['ui', 'listPresentation', 'view']);

export const getCurrentView = createSelector(
  getCurrentViewFromState,
  currentView => currentView
);

export default {
  getCurrentView
};
